module.exports = __webpack_public_path__ + "static/media/mining.2bbb1bc5.png";